// dependencies
import React from 'react';
import { FaClipboardList } from 'react-icons/fa';
import './Terms.css';

const Terms = () => {
   return (
      <div style={{ textAlign: 'center' }} className="content common-blue">
         <div className="tos-container">
            <h2 className="text"> Terms Of Service </h2>
            <hr />
            <p>
               <span className="terms-item">
                  <FaClipboardList />
               </span>
               Our application relies on data collected from results published
               by
               <b> Bangladesh Technical Education Board</b>.
            </p>
            <span> ..... </span>
            <p>
               <span className="terms-item">
                  <FaClipboardList />
               </span>
               We do not guarantee that the result will be 100% accurate, though
               the chances of errors are meager.
            </p>
            <span> ..... </span>
            <p>
               <span className="terms-item">
                  <FaClipboardList />
               </span>
               This is an entirely non-profit application, and we have used free
               cloud hosting to deploy this application. Therefore,
               server-related problems may occur sometimes.
            </p>
            <span> ..... </span>
            <p>
               <span className="terms-item">
                  <FaClipboardList />
               </span>
               {/* If the website is not visited for 30 minutes in a row, the server
               stops. So, there may be a slight delay in getting results for the
               first time. */}
               In the case of group results, try not to enter any roll number
               which has a range of more than 1000 - 1500. Otherwise, your browser may
               hang!
            </p>
            <span> ..... </span>
            <p>
               <span className="terms-item">
                  <FaClipboardList />
               </span>
               This domain is valid for a maximum of one year. So after one
               year, you may not find this website under this domain name. We
               may or may not renew this domain.
            </p>
         </div>
      </div>
   );
};

export default Terms;
